// index.ts
function set(state, keyOrValue, valueOrUndefined, noChangeNoop) {
  if (valueOrUndefined === void 0 && !(state instanceof Array) && typeof keyOrValue === "object") {
    return merge(state, keyOrValue, noChangeNoop);
  }
  let isAtom = state instanceof Array && valueOrUndefined === void 0;
  let key = isAtom ? 0 : keyOrValue;
  let valueOrFunction = isAtom ? keyOrValue : valueOrUndefined;
  let oldValue = state[key];
  let value = typeof valueOrFunction === "function" ? valueOrFunction(oldValue) : valueOrFunction;
  if (noChangeNoop && value === oldValue) return;
  state[key] = value;
  if (isAtom) {
    emit(state, value, oldValue);
  } else {
    emit(state, key, value, oldValue);
    emit(state, void 0, key, value, oldValue);
  }
}
function update(state, key) {
  if (key !== void 0) {
    let value = state[key];
    emit(state, key, value);
    emit(state, void 0, key, value);
  } else {
    if (state instanceof Array) {
      emit(state, state[0]);
    } else {
      emit(state, void 0);
    }
  }
}
function merge(state, newState, noChangeNoop) {
  let oldState = {};
  for (let key in newState) {
    oldState[key] = state[key];
    state[key] = newState[key];
  }
  for (let key in newState) {
    if (noChangeNoop && oldState[key] === newState[key]) continue;
    emit(state, key, newState[key], oldState[key]);
    emit(state, void 0, key, newState[key], oldState[key]);
  }
}
function on(state, keyOrListener, listenerOrNone) {
  let events = getEvents(state);
  let [key, listener] = getKeyListener(keyOrListener, listenerOrNone);
  if (!events.has(key)) events.set(key, new Set());
  events.get(key).add(listener);
  return () => off(state, key, listener);
}
function off(state, keyOrListener, listenerOrNone) {
  let events = getEvents(state);
  let [key, listener] = getKeyListener(keyOrListener, listenerOrNone);
  let listeners = events.get(key);
  if (!listeners) return;
  listeners.delete(listener);
  if (listeners.size === 0) events.delete(key);
}
function emit(state, keyOrArg) {
  let isAtom = state instanceof Array;
  let key = isAtom ? void 0 : keyOrArg;
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  let fullArgs = isAtom ? [keyOrArg, ...args] : args;
  let events = getEvents(state);
  if (!events.has(key)) return;
  for (let listener of events.get(key)) {
    try {
      listener(...fullArgs);
    } catch (err) {
      console.error(err);
    }
  }
}
function clear(state) {
  getEvents(state).clear();
}
function pure(state) {
  if (state instanceof Array) return state[0];
  let {
    set: set2,
    update: update2,
    on: on2,
    emit: emit2,
    clear: clear2,
    _events,
    ...rest
  } = state;
  return rest;
}
function once(state, key, listener) {
  let listener_ = function () {
    off(state, key, listener_);
    listener(...arguments);
  };
  return on(state, key, listener_);
}
function next(state, key) {
  return new Promise(r => once(state, key, value => r(value)));
}
async function until(state, key, condition) {
  let value = state[key];
  if (condition ? condition(value) : value) {
    return;
  } else {
    return new Promise(resolve => {
      let off2 = on(state, key, value2 => {
        if (condition ? condition(value2) : value2) {
          off2();
          resolve();
        }
      });
    });
  }
}
function is(state, keyOrValue, valueOrUndefined) {
  set(state, keyOrValue, valueOrUndefined, true);
}
var EV = new Map();
function getEvents(state) {
  return state._events || EV.get(state) || EV.set(state, new Map()).get(state);
}
function getKeyListener(keyOrListener, listenerOrNone) {
  let noKey = listenerOrNone === void 0;
  let key = noKey ? void 0 : keyOrListener;
  let listener = noKey ? keyOrListener : listenerOrNone;
  return [key, listener];
}
function State(initialState, options) {
  let _events = new Map();
  let api = {
    set(key, valueOrFunction) {
      set(state, key, valueOrFunction);
    },
    update(key) {
      update(state, key);
    },
    on(key, listener) {
      return on(state, key, listener);
    },
    emit(key) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      emit(state, key, ...args);
    },
    clear() {
      clear(state);
    },
    _events
  };
  let state = (options == null ? void 0 : options.minimal) ? Object.assign({
    _events
  }, initialState) : Object.assign({}, initialState, api);
  if (options == null ? void 0 : options.debug) {
    on(state, (key, value) => {
      console.log("update", key, value);
    });
  }
  return state;
}
var minimal_state_default = State;
export { clear, minimal_state_default as default, emit, is, next, off, on, once, pure, set, until, update };